var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGranoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m32.12 43.12a9 9 0 0 1 -6.36-2.63l-4.25-4.25a9 9 0 0 1 12.73-12.73l4.25 4.25a9 9 0 0 1 -6.37 15.36zm-4.24-20.24a7 7 0 0 0 -4.95 12l4.24 4.24a7 7 0 1 0 9.9-9.9l-4.24-4.24a7 7 0 0 0 -4.95-2.1z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.78 40.78a1 1 0 0 1 -.93-.63l-1-2.43a7.68 7.68 0 0 0 -6-4.73 9.68 9.68 0 0 1 -7.6-6l-1-2.43a1 1 0 0 1 1.86-.74l1 2.43a7.68 7.68 0 0 0 6 4.73 9.68 9.68 0 0 1 7.6 6l1 2.43a1 1 0 0 1 -.56 1.3 1 1 0 0 1 -.37.07z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 58h-44a7 7 0 0 1 -7-7v-38a7 7 0 0 1 7-7h44a7 7 0 0 1 7 7v38a7 7 0 0 1 -7 7zm-44-50a5 5 0 0 0 -5 5v38a5 5 0 0 0 5 5h44a5 5 0 0 0 5-5v-38a5 5 0 0 0 -5-5z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 38a3 3 0 0 1 -3-3v-6a3 3 0 0 1 6 0v6a3 3 0 0 1 -3 3zm0-10a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0 -1-1z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 58a1 1 0 0 1 -1-1v-50a1 1 0 0 1 2 0v50a1 1 0 0 1 -1 1z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 35a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z",
    fill: "#000000",
    style: {
      fill: "rgb(220, 165, 76)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGranoIcon);
export default __webpack_public_path__ + "static/media/grano-icon.675fd025010fe3664601e65ef45bb4ac.svg";
export { ForwardRef as ReactComponent };